import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { getAstroInfo, formatDateRu } from '../utils/astroUtils';
import Marquee from '../components/Marquee';
import DashboardNatalSummary from '../components/dashboard/DashboardNatalSummary';
import DashboardDailyForecast from '../components/dashboard/DashboardDailyForecast';
import DashboardTransits from '../components/dashboard/DashboardTransits';
import DashboardRetrogrades from '../components/dashboard/DashboardRetrogrades';
import DashboardQuickActions from '../components/dashboard/DashboardQuickActions';
import { cardStyle, CardDecorations, goldShimmerKeyframes } from '../components/dashboard/dashboardStyles';

const DashboardPage: React.FC = () => {
  const { user } = useAuth();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const astroInfo = getAstroInfo();
  const currentDate = formatDateRu();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const subscriptionLabel = user?.subscription_status === 'active'
    ? 'Премиум'
    : user?.subscription_status === 'trial'
      ? 'Пробный период'
      : null;

  const subscriptionColor = user?.subscription_status === 'active'
    ? '#d4af37'
    : '#a0c4ff';

  return (
    <>
      <style>{goldShimmerKeyframes}</style>
      <Marquee />
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto',
        padding: isMobile ? '20px 16px' : '32px 20px',
        fontFamily: 'var(--font-sans)',
      }}>
        {/* Greeting card */}
        <div style={{
          ...cardStyle,
          padding: isMobile ? '16px 14px' : '28px 24px',
          marginBottom: '24px',
        }}>
          <CardDecorations />
          <div style={{ position: 'relative', zIndex: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '8px' }}>
            <div>
              <h1 style={{
                fontSize: isMobile ? '24px' : '30px',
                fontFamily: 'var(--font-display)',
                fontStyle: 'italic',
                background: 'linear-gradient(135deg, #F4E4A6 0%, #D4AF37 40%, #B8942B 70%, #F4E4A6 100%)',
                backgroundSize: '200% auto',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                marginBottom: '6px',
                animation: 'goldShimmer 3s ease-in-out infinite',
              }}>
                Добро пожаловать, {user?.full_name?.split(' ')[0] || 'пользователь'}!
              </h1>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                <p style={{ color: '#b0b0b0', fontSize: isMobile ? '11px' : '13px', marginBottom: '0' }}>
                  {currentDate}
                </p>
                <span style={{ color: '#888', fontSize: '12px' }}>
                  {astroInfo.sunSignIcon} {astroInfo.sunSign} · {astroInfo.moonPhaseIcon} {astroInfo.moonPhase}
                </span>
              </div>
            </div>
            {subscriptionLabel && (
              <span style={{
                background: `${subscriptionColor}15`,
                border: `1px solid ${subscriptionColor}40`,
                color: subscriptionColor,
                fontSize: '12px',
                fontWeight: 600,
                padding: '6px 14px',
                borderRadius: '20px',
                whiteSpace: 'nowrap',
              }}>
                ✦ {subscriptionLabel}
              </span>
            )}
          </div>
        </div>

        {/* Big Three — Natal Summary */}
        <DashboardNatalSummary />

        {/* Forecast — full width */}
        <DashboardDailyForecast />

        {/* Transits — full width */}
        <DashboardTransits />

        {/* Retrogrades — compact strip */}
        <DashboardRetrogrades />

        {/* Quick Actions */}
        <DashboardQuickActions />
      </div>
    </>
  );
};

export default DashboardPage;
